import './BookingDetailPage.scss'
import { Button, Col, Modal, notification, Popconfirm, Row, Tag, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import BookingData, { BookingLine, Extra } from '../../../models/BookingData';
import { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment';
import HTMLReactParser from 'html-react-parser';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { GetShowMoreIcon } from '../../../utils/icons';
import { CancellationPolicies, Occupation } from '../../../components';
import { cancelBooking, changeBookingStatus, doPreAuthorizationPayment, fetchBookingData, 
fetchBookingStatus, GetPaymentMethodById, getRequestDataToPreAuthorization, performBooking, 
GetPaymentsMethods, sendEmailToCustomer, simulateCancelBooking, voidTPVPayment } from '../../../api/repositoryEP';import { ClockCircleOutlined, CloseCircleOutlined, InfoCircleOutlined, LoadingOutlined, MailOutlined, PlayCircleOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { useNavigate } from 'react-router-dom';
import { GetFormattedUrl } from '../../../utils/urls';
import MoneyComponent from '../../../components/common/MoneyComponent/MoneyComponent';
import { SessionDataProvider, useSessionData } from '../../../Contexts/SessionDataContext';
import { BookingStatusInfo, CANCELLED_BY_USER, ErrorStatus, GUEST } from '../../../utils/constants';
import LoadingDataComponent from '../../../components/common/LoadingData/LoadingDataComponent';
import { PaymentPreAuthorizationRequestTPVData, PreAuthorizationTPVData } from '../../../models/entities/booking/TPVData';
import { isVisible } from '@testing-library/user-event/dist/utils';
import { format } from 'path';

import NMIComponent from '../../../components/NMI/NmiComponent';
import { use } from 'i18next';
import { buildBookingDetailsEmailHtml } from '../../../utils/bookingEmailTemplate';



interface BookingDetailPageProps {
    bookingData?: BookingData;
    setBookingData: (bookingData: BookingData) => void;
}
const BookingDetailPage = (props: BookingDetailPageProps): JSX.Element => {

    const appConfig = useAppConfig();
    const [hasFailedPreAuthorization, setHasFailedPreAuthorization] = useState<boolean>(false);
    const [detailTooltip, setDetailTooltip] = useState<{ message: string; x: number; y: number } | null>(null);

    const { bookingData } = props;

    const { t, i18n } = useTranslation();


    const [visible, setVisible] = useState<boolean>(false);

    const toogleVisibility = () => {
        setVisible(!visible);
    }

    const [netPrice, setNetPrice] = useState<number>(0);
    const [commission, setCommission] = useState<number>(0);
    const [pvpPrice, setPvpPrice] = useState<number>(0);
    const [totalBooking, setTotalBooking] = useState<number>(0);
    const [currencyBooking, setCurrencyBooking] = useState<string>('');
    useEffect(() => { console.log(props.bookingData); }, [props.bookingData])

    useEffect(() => {

        if (bookingData) {
            var totalBookingPvp = bookingData.bookingLines.reduce((acc, bookingLine) => acc + bookingLine.pvp, 0);
            var totalBookingNet = bookingData.bookingLines.reduce((acc, bookingLine) => acc + bookingLine.net, 0);
            var totalCommissions = bookingData.bookingLines.reduce((acc, bookingLine) => acc + bookingLine.commission, 0);

            setCommission(totalCommissions);
            setPvpPrice(totalBookingPvp);
            setNetPrice(totalBookingNet);
            setTotalBooking(bookingData.isNetPrice ? totalBookingNet : totalBookingPvp);
            setCurrencyBooking(bookingData.currencyCode);

            if (bookingData.statusName == "error" && (bookingData.statusInfo === BookingStatusInfo.ERROR_PRE_AUTHORIZATION || bookingData.statusInfo === BookingStatusInfo.CANCELLED_BY_USER)) {
                setHasFailedPreAuthorization(true)

            }
        }

    }, [bookingData])


    const center = {
        lat: bookingData?.hotelInfo.latitude ?? 0,
        lng: bookingData?.hotelInfo.longitude ?? 0
    };

    const containerStyle = {
        width: '100%',
        height: '206.359px'
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyC34CpfBPB0eXXmONTzlreC2nt7atGRir0"
    })

    const [map, setMap] = useState<google.maps.Map | null>(null)

    const onLoad = useCallback(function callback(map: google.maps.Map) {

        map.setZoom(14);

        const markerPosition = { lat: bookingData?.hotelInfo.latitude ?? 0, lng: bookingData?.hotelInfo.longitude ?? 0 };

        const marker = new google.maps.Marker({
            position: markerPosition,
            map: map,
            title: bookingData?.hotelInfo.name,
        });

        setMap(map)
    }, [])

    const onUnmount = useCallback(function callback(map: any) {
        setMap(null)
    }, [])



    const [cancelligData, setCancelligData] = useState<boolean>(false);


    const cancelReservation = (): void => {
        //Si la reserva tiene políticas de cancelación que apliquen se muestra un mensaje de alerta

        if (bookingData) {
            setCancelligData(true);
            cancelBooking(bookingData.id).then((response) => {
                if (response && response.code === 200) {
                    bookingData.isCancelled = true;
                    bookingData.statusName = 'canceled';
                    bookingData.lastUpdateDate = new Date();
                    props.setBookingData(bookingData);
                }

            }).finally(() => {
                setCancelligData(false);
            });
        }
    }

    const [isSendingCopyByEmail, setIsSendingCopyByEmail] = useState<boolean>(false);
    const [isSendingDisabled, setIsSendingDisabled] = useState<boolean>(false);
    const [leftTimeToEnableSendButton, setLeftTimeToEnableSendButton] = useState<number>(0);
    const sendCopyByEmail = (): void => {
        if (bookingData) {
            setIsSendingCopyByEmail(true);
            sendEmailToCustomer(
                bookingData.id,
                buildBookingDetailsEmailHtml(bookingData)
            ).then((response) => {
                if (response?.type == 1) {
                    setIsSendingDisabled(true);
                    setTimeout(() => { setIsSendingDisabled(false); }, 30000);
                    setLeftTimeToEnableSendButton(30);
                    const interval = setInterval(() => {
                        setLeftTimeToEnableSendButton((prev) => {
                            if (prev <= 1) { clearInterval(interval); return 0; }
                            return prev - 1;
                        });
                    }, 1000);
                }
            }).finally(() => {
                setIsSendingCopyByEmail(false);
            });
        }
    }

    const navigate = useNavigate();
    const goCustomerVoucher = (): void => {
        navigate(GetFormattedUrl(`private/customer-voucher/${bookingData?.pmsLocator}`));
    }


    const [gettingCancelationFees, setGettingCancelationFees] = useState<boolean>(false);
    const [cancelationFees, setCancelationFees] = useState<number | undefined>();
    const onGetBookingCancelSimulationAmount = (): void => {
        if (bookingData) {
            setGettingCancelationFees(true);
            simulateCancelBooking(bookingData.id).then((response) => {
                if (response && response.data && response.code === 200) {
                    setCancelationFees(response.data.amount);
                }
            })
                .finally(() => {
                    setGettingCancelationFees(false);
                });
        }
    }



    const theBookingHasntStartedYet = (checkIn: string | Date): boolean => {
        const checkInDate = new Date(checkIn); // convierte string a Date si es necesario
        const now = new Date(); // fecha y hora actual

        return checkInDate >= now;
    };



    useEffect(() => {
        const resumeLinks = document.querySelectorAll(".resume-link");

        resumeLinks.forEach((resumeLink: any) => {
            const handleClick = (event: MouseEvent) => {
                event.preventDefault();
                const tag = (event.currentTarget as HTMLAnchorElement)?.getAttribute(
                    "id"
                );
                const element = document.querySelector(`[data-tag='${tag}']`);
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                }
            };

            resumeLink.addEventListener("click", handleClick);

            return () => {
                resumeLink.removeEventListener("click", handleClick);
            };
        });
    }, []);


    const [visibleModal, setVisibleModal] = useState<boolean>(false);
    const [loadingRetry, setLoadingRetry] = useState<boolean>(false);
    const [loadingCancelation, setLoadingCancelation] = useState<boolean>(false);
    const [isCancelling, setIsCancelling] = useState<boolean>(false);
    const [countdown, setCountdown] = useState<number>(360); // 6 minutos en segundos
    const [formPaymentData, setFormPaymentData] = useState<string>("");
    const [showNMI, setShowNMI] = useState<boolean>(false);
    const [tokenizationKeyNMI, setTokenizationKeyNMI] = useState<string>("");

    const isNMISelected = bookingData?.paymentMethodCode?.toLowerCase().includes("nmi") ?? false;

    const popupRef = useRef<Window | null>(null);
    const handledPopupClose = useRef(false);

    const cancelBookingPreAuthorization = async () => {
        changeBookingStatus(bookingData?.id || "", ErrorStatus, BookingStatusInfo.ERROR_PRE_AUTHORIZATION).then(() => {
        });
        setVisibleModal(false);
    }

    const cancelBookingPreAuthWithPosponedStatus = async () => {
        changeBookingStatus(bookingData?.id || "", "postponed", "").then(() => {
        });
        setVisibleModal(false);
    }



    useEffect(() => {
        if (formPaymentData) {
            // Esperamos un pequeño delay para asegurar que el DOM del modal está montado
            setTimeout(() => {
                const container = document.getElementById("tpv-form-container");
                if (container) {
                    const form = container.querySelector("form");
                    if (form) {
                        form.setAttribute("target", "tpvIframe");
                        form.submit();
                        setVisibleModal(true);

                    }
                }
            }, 100);
        }
    }, [formPaymentData]);

    const handleSuccessfulBooking = async (bookingId: string) => {

        // Obtener los datos de la reserva para redirigir
        const bookingData = await fetchBookingData(bookingId, "", i18n.language);
        // console.log("El booking data es:", bookingData);

        // Extraer el localizador de la reserva
        const bookingLocator = bookingData?.data?.pmsLocator || "";

        // Desactivar el estado de espera de pago
        setVisibleModal(false);

        // Redirigir al voucher del cliente
        navigate(GetFormattedUrl(`private/payment-ok-customer-voucher/${bookingLocator}`));

    };

    const retryPreAuthorization = async () => {
        console.log("Reintentando preautorización...");
        setLoadingRetry(true);
        setCountdown(360);
        //cerramos popup si está abierto
        if (popupRef.current && !popupRef.current.closed) {
            popupRef.current.close();
        }
        popupRef.current = null;

        await changeBookingStatus(bookingData?.id || "", "pending", "");

        if (isNMISelected) {
            setHasFailedPreAuthorization(false);
            setVisibleModal(false);
            setLoadingRetry(false);
            setShowNMI(true);
        } else {
            setVisibleModal(true);
            setTimeout(async () => {

                await getPaymentForm(bookingData?.id || "");


                handledPopupClose.current = false; // 🔹 Reinicia la referencia de control del cierre


                setHasFailedPreAuthorization(false);
                setVisibleModal(false);
                setTimeout(() => setVisibleModal(true), 0); // fuerzo el tick para que cambie el estado



                setLoadingRetry(false);
            }, 200);
        }
    };

    function parseAmount(amountStr: string): number {
        const amountNum = Number(amountStr);
        if (isNaN(amountNum)) return 0;
        return amountNum / 100;
    }
    function calculateQuantityToBePaid(total: number, paid: number): number {
        return total - paid;
    }

    const isStripeSelected = bookingData?.paymentMethodCode.toLowerCase().includes("tpv")
        && bookingData?.paymentMethodCode.toLowerCase().includes("stripe");

    useEffect(() => {
        if (isNMISelected) {
            GetPaymentsMethods().then(response => {
                if (response?.type === 1 && response.data) {
                    const nmiMethod = response.data.find((pm: any) => pm.refCode?.toLowerCase().includes("nmi"));
                    if (nmiMethod) {
                        GetPaymentMethodById(nmiMethod.id).then(res => {
                            if (res?.type === 1 && res.data) {
                                const key = res.data.paymentMethodMetas.find((meta: any) => meta.key === "TokenizationKey")?.value || "";
                                setTokenizationKeyNMI(key);
                            }
                        });
                    }
                }
            });
        }
    }, [isNMISelected]);





    // dividimos en dos casos:  
    // reserva postergada : hay que primero buscar la reserva para crear el requestdatapreauth
    //reesrva normal : con el getRequestDataToPreAuthorization
    const getPaymentForm = async (bngId: string, paymentToken: string | null = null): Promise<boolean> => {
        console.log("vamos a pagar");
        let requestDataPreAuth: PreAuthorizationTPVData | null = null;
        console.log("bookingData", bookingData)
        if (bookingData?.statusName === "postponed" ) {

            requestDataPreAuth = {
                idUser: bookingData?.ownerData.id || "",
                bookingId: bookingData?.id || "",
                amount: bookingData?.totalToPay || 0,        // uso de string literal para acceder a la propiedad
                currency: bookingData?.currencyCode,
                street1: bookingData?.billingInfo?.street1 || "",
                street2: bookingData?.billingInfo?.street2 || "",
                street3: bookingData?.billingInfo?.street3 || "",
                city: bookingData?.billingInfo?.city || "",
                postalCode: bookingData?.billingInfo?.postalCode || "",
                country: bookingData?.billingInfo?.country || "",
                paymentToken: paymentToken
            }


        } else if(bookingData?.statusName === "error" && bookingData?.statusInfo === BookingStatusInfo.ERROR_PRE_AUTHORIZATION){ 
            var res = await getRequestDataToPreAuthorization(bookingData?.id || "");
            if (res?.type == 1 && res?.data) {
                //    const data = res.data as PaymentPreAuthorizationRequestTPVData;
                const parsedData = JSON.parse(res.data);



                requestDataPreAuth = {
                    idUser: bookingData?.ownerData.id || "",
                    bookingId: bookingData?.id || "",
                    amount: parseAmount(parsedData["Amount"]),        // uso de string literal para acceder a la propiedad
                    currency: parsedData["Currency"],
                    street1: parsedData["BillingStreet1"],
                    street2: parsedData["BillingStreet2"],
                    street3: parsedData["BillingStreet3"],
                    city: parsedData["BillingCity"],
                    postalCode: parsedData["BillingPostalCode"],
                    country: parsedData["BillingCountry"],
                    paymentToken: paymentToken

                }
            }
        }

        console.log("requestDataPreAuth:", requestDataPreAuth);
        if (!requestDataPreAuth) {
            await changeBookingStatus(bngId, ErrorStatus, BookingStatusInfo.REDO_PREAUTHORIZATION_NOT_POSSIBLE);
            return false;
        }


        const response = await doPreAuthorizationPayment(requestDataPreAuth);
        if (response?.type == 1 && response?.data) {
            console.log("se hizo la pre ok ")


            setFormPaymentData(response.data.form);

            if (isNMISelected) {
                setVisibleModal(true);
                return true;
            }

            if (isStripeSelected) {

                const urlForm = response.data.form;
                window.open(urlForm, '_blank', 'noopener,noreferrer');

                return true;
            }

            const popup = window.open('', 'tpvWindow', 'width=600,height=800');
            popupRef.current = popup;

            if (popup && response.data.form) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(response.data.form, "text/html");
                const form = doc.querySelector("form");

                if (form) {
                    form.setAttribute("target", "tpvWindow");
                    document.body.appendChild(form); // lo añades al DOM actual
                    form.submit();
                    form.remove(); // limpieza
                    setVisibleModal(true);
                } else {
                    console.error("No se encontró el form en response.data.form");
                    return false;
                }
            }
            return true;
        } else { // si falla, le cambiamos el estado a que no se ha podido hacer la preautorización                     
            changeBookingStatus(bookingData?.id || "", ErrorStatus, BookingStatusInfo.REDO_PREAUTHORIZATION_NOT_POSSIBLE).then(() => { });
            return false;
        }

    };


    {
        useEffect(() => {
            let pollingInterval: NodeJS.Timeout;
            let countdownInterval: NodeJS.Timeout;
            let popupCheckInterval: NodeJS.Timeout;
            let settled = false; //  evita llamadas dobles
            let failed = false; //  evita llamadas dobles

            if (visibleModal) {
                console.log("ha entrado")
                const startTime = Date.now();
                const duration = 6 * 60 * 1000; // 6 minutos
                setCountdown(duration);
                // Polling cada 5 segundos
                pollingInterval = setInterval(async () => {
                    try {
                        const res = await fetchBookingStatus(bookingData?.id || "");
                        console.log("estado", res)

                        if (res?.type == 1) {
                            if (res.data?.status === "active" && !settled) {
                                settled = true; //  marca que ya ejecutamos settle
                                console.log(res.data)
                                clearInterval(pollingInterval);
                                clearInterval(countdownInterval);
                                handleSuccessfulBooking(bookingData?.id || "");


                            } else if (res.data?.statusInfo === BookingStatusInfo.ERROR_PRE_AUTHORIZATION || res.data?.statusInfo === BookingStatusInfo.CANCELLED_BY_USER) {
                                // aqui habilitamos un botón para reintentar pago y reseteamos reloj
                                console.log("fallo la preautorizacion");
                                console.log("estado: ", res.data?.statusInfo)

                                // Restaurar el estado anterior de la reserva
                                if (bookingData?.statusName === 'postponed') {
                                    changeBookingStatus(bookingData?.id || "", "postponed", "");
                                } else {
                                    changeBookingStatus(bookingData?.id || "", ErrorStatus, BookingStatusInfo.ERROR_PRE_AUTHORIZATION);
                                }

                                setHasFailedPreAuthorization(true);
                                setLoadingRetry(false);
                                clearInterval(pollingInterval);
                                clearInterval(countdownInterval);

                            } else if (!failed && (res.data?.statusInfo === BookingStatusInfo.ERROR_SETTLE || res.data?.statusInfo === BookingStatusInfo.ERROR_PERFORM_BOOKING_CONNECT)) {
                                setHasFailedPreAuthorization(true); // nos salimos
                                setLoadingRetry(false);

                                failed = true;
                                notification.warning({ //ERROR NO SE HA PODIDO REALIAR EL PAGO
                                    message: t("error.warning"),
                                    description: t("error.payment"),
                                });
                                props.setBookingData({
                                    ...props.bookingData,
                                    statusName: "error",
                                    statusInfo: res.data?.statusInfo
                                } as BookingData);
                                console.log("cambiado")


                                setVisibleModal(false);
                                clearInterval(pollingInterval);
                                clearInterval(countdownInterval);
                                clearInterval(popupCheckInterval);



                            }

                        }

                    } catch (error) {
                        console.error("Error consultando el estado de pago:", error);
                    }
                }, 5000);

                // ⏱️ Cuenta atrás
                countdownInterval = setInterval(() => {
                    const elapsed = Date.now() - startTime;
                    const remainingSeconds = Math.max(0, Math.ceil((duration - elapsed) / 1000));
                    setCountdown(remainingSeconds);

                    if (remainingSeconds <= 0) {
                        clearInterval(pollingInterval);
                        clearInterval(countdownInterval);

                        setIsCancelling(true); // si lo cancela , e entonces ponemos la reserva en estado error, error_preauthorization
                        changeBookingStatus(bookingData?.id || "", ErrorStatus, BookingStatusInfo.ERROR_PRE_AUTHORIZATION).then(() => {
                            console.log("cambiado el estado");
                        });
                        handleVoidPayment().finally(() => {
                            setIsCancelling(false);
                            setVisibleModal(false);
                        });

                    }
                }, 1000);



                popupCheckInterval = setInterval(async () => {
                    if (popupRef.current && popupRef.current.closed && !handledPopupClose.current) {
                        handledPopupClose.current = true; // 🔒 Solo entra una vez
                        clearInterval(popupCheckInterval);

                        console.log("Ventana TPV cerrada por el usuario");

                        //  Esperamos 1 segundo para dar tiempo a Redsys/GetTPVResponse
                        await new Promise(resolve => setTimeout(resolve, 1000));

                        const res = await fetchBookingStatus(bookingData?.id || "");

                        if (res?.type === 1 && res?.data?.status === "pending" && res.data?.processingPayment === false) {
                            clearInterval(pollingInterval);
                            clearInterval(countdownInterval);

                            // Restaurar el estado anterior de la reserva
                            if (bookingData?.statusName === 'postponed') {
                                await changeBookingStatus(bookingData?.id || "", "postponed", "");
                            } else {
                                await changeBookingStatus(bookingData?.id || "", ErrorStatus, BookingStatusInfo.ERROR_PRE_AUTHORIZATION);
                            }

                            setHasFailedPreAuthorization(true);
                            console.log("El usuario ha cerrado la ventana de pago sin completar el proceso.");
                            notification.error({
                                message: t("error.error"),
                                description: t("error.payment"),
                            });
                        }
                    }
                }, 1000);


            }


            // Si el usuario cierra el navegador mientras espera el pago, marcamos la reserva como error
            const handleBeforeUnload = () => {
                if (visibleModal && bookingData?.id && !settled) {
                    const url = `${process.env.REACT_APP_BASE_API}/${process.env.REACT_APP_API_VERSION}/Bookings/ChangeBookingStatus`;
                    const token = sessionStorage.getItem('token');
                    const payload = JSON.stringify({
                        bookingId: bookingData.id,
                        status: ErrorStatus,
                        statusInfo: BookingStatusInfo.ERROR_PRE_AUTHORIZATION
                    });
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token ? { 'X-Authorization': `bearer ${token}` } : {}),
                            'Authority': window.location.host
                        },
                        body: payload,
                        keepalive: true
                    });
                }
            };

            if (visibleModal) {
                window.addEventListener('beforeunload', handleBeforeUnload);
            }

            return () => {
                clearInterval(pollingInterval);
                clearInterval(countdownInterval);
                clearInterval(popupCheckInterval);
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }, [visibleModal, bookingData?.id]);

        const isPostponed = bookingData?.statusName === 'postponed';


        const retryTooltipText = isPostponed
            ? t('helper.retry-postponed-booking') // 
            : t(
                bookingData?.typeCardPayment === "guest"
                    ? "helper.verification-code-guest"
                    : "helper.verification-code-agent"
            );

        const retryIconColor = isPostponed ? 'orange' : 'red';

        const [loadingPerformBooking, setLoadingPerformBooking] = useState<boolean>(false);
        const [showPerformBookingModal, setShowPerformBookingModal] = useState<boolean>(false);

const resumePostponedBooking = async () => {
    if (!bookingData?.id) return;

    setHasFailedPreAuthorization(false);       //  de develop
    handledPopupClose.current = false;          // de develop
    setLoadingRetry(true);
    setCountdown(360);

    if (popupRef.current && !popupRef.current.closed) {
        popupRef.current.close();
    }
    popupRef.current = null;

    await changeBookingStatus(bookingData.id, "pending", "");

    if (isNMISelected) {                        //  de feature/nmi
        setHasFailedPreAuthorization(false);
        setLoadingRetry(false);
        setShowNMI(true);
    } else {
        setVisibleModal(true);                  //  de develop
        setTimeout(async () => {
            await getPaymentForm(bookingData.id);
            handledPopupClose.current = false;
            setHasFailedPreAuthorization(false);
            setLoadingRetry(false);
        }, 200);
    }
};

        const resumePostponedBookingWithoutTPV = async () => {
            if (!bookingData?.id) return;

            setShowPerformBookingModal(true);
            setLoadingPerformBooking(true);

            try {
                const res = await performBooking(
                    {
                        bookingIdPro: bookingData.id,
                        isPostponed: true
                    },
                    bookingData.id
                );

                if (res && res.type === 1 && res.data?.locator) {
                    notification.success({
                        message: t('loading-payment.payment'),
                        description: t('loading-payment.booking-confirmed'),
                    });
                    props.setBookingData({
                        ...bookingData,
                        statusName: 'active',
                        pmsLocator: res.data.locator
                    } as BookingData);
                } else {
                    notification.error({
                        message: t('error.error'),
                        description: t('error.perform-booking'),
                    });
                    await changeBookingStatus(bookingData.id, ErrorStatus, BookingStatusInfo.ERROR_FAILED_POSTPONED);
                    props.setBookingData({
                        ...bookingData,
                        statusName: 'error',
                        statusInfo: BookingStatusInfo.ERROR_FAILED_POSTPONED
                    } as BookingData);
                }
            } catch (error) {
                console.error('Error performing postponed booking:', error);
                notification.error({
                    message: t('error.error'),
                    description: t('error.perform-booking'),
                });
                await changeBookingStatus(bookingData.id, ErrorStatus, BookingStatusInfo.ERROR_FAILED_POSTPONED);
                props.setBookingData({
                    ...bookingData,
                    statusName: 'error',
                    statusInfo: BookingStatusInfo.ERROR_FAILED_POSTPONED
                } as BookingData);
            } finally {
                setLoadingPerformBooking(false);
                setShowPerformBookingModal(false);
            }
        };

        const isTPVPaymentMethod = bookingData?.paymentMethodCode?.toLowerCase().includes('tpv');

        const [confirmRetryVisible, setConfirmRetryVisible] = useState<boolean>(false);
        const [confirmRetryLoading, setConfirmRetryLoading] = useState<boolean>(false);

        const handleRetryClick = () => {
            if (bookingData?.statusName === 'postponed') {
                setConfirmRetryVisible(true);
            } else {
                setVisibleModal(true);
            }
        };

        const handleConfirmRetry = async () => {
            setConfirmRetryLoading(true);
            try {
                if (isTPVPaymentMethod) {
                    await resumePostponedBooking();
                } else {
                    await resumePostponedBookingWithoutTPV();
                }
            } finally {
                setConfirmRetryLoading(false);
                setConfirmRetryVisible(false);
            }
        };




        const handleVoidPayment = async () => {
            if (isCancelling) return; // previene doble ejecución

            setIsCancelling(true);
            try {

                const res = await voidTPVPayment(bookingData?.id || ""); // si falla el void, ya se notificado

                if (res?.type === 1 && res.data?.voidCorrect === true) {
                    // SI HA IDO BIEN LA LIBERACIÓN...  flujo ok

                } else if (res?.code != 200) { // es decir que no se haya hecho bien la peticion o algo por el estilo
                    await changeBookingStatus(bookingData?.id || "", ErrorStatus, "ERROR_VOIDING");

                }
            } catch (error) {
                console.error("Error anulando el pago:", error);
                await changeBookingStatus(bookingData?.id || "", ErrorStatus, "ERROR_VOIDING");

            } finally {
                notification.error({
                    message: t("error.error"),
                    description: t("error.payment"),
                });
                setVisibleModal(false); // cierra el modal
                setIsCancelling(false); // vuelve a permitir cancelar si se reabre
                navigate(GetFormattedUrl("private/dashboard"));
            }
        };


        useEffect(() => {
            if (visibleModal) {
                setLoadingRetry(false);
            }
        }, [visibleModal]);




        return (
            <>
            <div className="booking-detail-page ">
                <NMIComponent
                    open={showNMI && isNMISelected}
                    hotelName={bookingData?.hotelInfo?.name || ""}
                    amount={bookingData?.totalToPay || 0}
                    currency={bookingData?.currencyCode || ""}
                    tokenizationKey={tokenizationKeyNMI}
                    onSuccess={async (token) => {
                        const success = await getPaymentForm(bookingData?.id || "", token);
                        setShowNMI(false);
                        if (success) {
                            setVisibleModal(true);
                        } else {
                            setHasFailedPreAuthorization(true);
                            setVisibleModal(true);
                        }
                    }}
                    onCancel={() => {
                        setShowNMI(false);
                        if (bookingData?.statusName === 'postponed' || bookingData?.statusName === 'pending') {
                            changeBookingStatus(bookingData?.id || "", "postponed", "");
                        } else {
                            changeBookingStatus(bookingData?.id || "", ErrorStatus, BookingStatusInfo.ERROR_PRE_AUTHORIZATION);
                        }
                    }}
                />
                <Modal
                    className="app-modal"
                    title={t('pages.booking-detail.confirm-retry.title')}
                    open={confirmRetryVisible}
                    centered
                    closable={!confirmRetryLoading}
                    onCancel={() => { if (!confirmRetryLoading) setConfirmRetryVisible(false); }}
            
                    footer={
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: -1 }}>
                            <Button className="app-white-button" disabled={confirmRetryLoading} onClick={() => setConfirmRetryVisible(false)}>
                                {t('pages.booking-detail.confirm-retry.cancel')}
                            </Button>
                            <Button className="app-button" loading={confirmRetryLoading} disabled={confirmRetryLoading} onClick={handleConfirmRetry}>
                                {t('pages.booking-detail.confirm-retry.ok')}
                            </Button>
                        </div>
                    }
                >
                    <p style={{ margin: '16px 0' }}>{t('pages.booking-detail.confirm-retry.description')}</p>
                </Modal>
                <Modal
                    className="app-modal"
                    title={t("loading-payment.payment")}
                    open={visibleModal}
                    footer={null}
                    closable={false}
                >
                    {isCancelling && (
                        <LoadingDataComponent text={t("loading-payment.wait-a-moment") || ""} />
                    )}
                    {!isCancelling && (

                        <>

                            {hasFailedPreAuthorization ? (
                                <>
                                    <Typography.Paragraph style={{ textAlign: "center", marginTop: 16 }}>
                                        {t('loading-payment.payment-unsuccessful')}
                                    </Typography.Paragraph>
                                    <Typography.Paragraph style={{ textAlign: "center", marginTop: 16 }}>
                                        {t('loading-payment.payment-retry')}
                                    </Typography.Paragraph>
                                    <Typography.Paragraph style={{ textAlign: "center", marginTop: 16 }}>
                                        <Button
                                            type="default"
                                            className='app-button'
                                            onClick={retryPreAuthorization}
                                            loading={loadingRetry}
                                            disabled={loadingRetry || loadingCancelation}

                                        >
                                            {t('button.retry')}
                                        </Button>
                                    </Typography.Paragraph>

                                    <Typography.Paragraph style={{ textAlign: "center", marginTop: 16 }}>
                                        <Button
                                            type="default"
                                            className='app-button'
                                            loading={loadingCancelation}
                                            disabled={loadingCancelation || loadingRetry}
                                            onClick={bookingData?.statusName == 'error' ? cancelBookingPreAuthorization : cancelBookingPreAuthWithPosponedStatus}
                                        >
                                            {t('button.cancel')}
                                        </Button>
                                    </Typography.Paragraph>

                                </>

                            ) : (
                                <>
                                    {!isNMISelected && (
                                        <Typography.Paragraph style={{ textAlign: "center", marginTop: 16 }}>
                                            {t('loading-payment.pay')}
                                        </Typography.Paragraph>
                                    )}

                                    <Typography.Paragraph style={{ textAlign: "center", marginTop: 16 }}>
                                        {t('loading-payment.please-wait')}
                                    </Typography.Paragraph>

                                    <LoadingDataComponent text=" " />
                                    <Typography.Text style={{ display: "block", textAlign: "center", marginBottom: 16 }}>
                                        {t('loading-payment.remain-time')} {Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, "0")} {t("loading-payment.minutes")}
                                    </Typography.Text>
                                    <Button
                                        type="default"
                                        disabled
                                        loading
                                        block
                                    >
                                        {t('loading-payment.waiting')}
                                    </Button>
                                </>
                            )}



                        </>
                    )}


                </Modal>
                <Modal
                    className="app-modal"
                    title={t("loading-payment.processing-booking")}
                    open={showPerformBookingModal}
                    footer={null}
                    closable={false}
                >
                    <LoadingDataComponent text={t("loading-payment.wait-a-moment") || ""} />
                </Modal>
                <div className="print-page">
                    <div className="resume print-block">
                        <Row gutter={0} >
                            <Col xs={24} lg={16} className="background-image-resume" style={{ marginBottom: 20, backgroundImage: `url(${bookingData?.hotelInfo.mainImage})` }}>
                            </Col>
                            <Col xs={24} lg={8}>
                                {
                                    isLoaded ? <GoogleMap
                                        mapContainerStyle={containerStyle}
                                        center={center}
                                        onLoad={onLoad}
                                        options={{
                                            //https://developers.google.com/maps/documentation/javascript/reference?csw=1#MapOptions
                                            zoomControl: false, // Deshabilita el control de zoom
                                            streetViewControl: false, // Deshabilita el control de Street View
                                            mapTypeControl: false, // Deshabilita el control de tipo de mapa
                                            scaleControl: false, // Deshabilita el control de escala
                                            rotateControl: false, // Deshabilita el control de rotación
                                            fullscreenControl: true, // Habilita el control de pantalla completa
                                        }}
                                        onUnmount={onUnmount}
                                    >
                                        { /* Child components, such as markers, info windows, etc. */}

                                        <Marker title={bookingData?.hotelInfo.name} position={{ lat: bookingData?.hotelInfo.latitude ?? 0, lng: bookingData?.hotelInfo.longitude ?? 0 }} />
                                        <></>
                                    </GoogleMap> : <>{t("components.google-components.google-maps.loading")}</>
                                }
                            </Col>
                            <Col xs={24} lg={14} className="content">
                                <h3 className="main-title">
                                    {
                                        t('pages.booking-detail.main-title')
                                    }
                                </h3>
                                <h3 className="hotel-name">
                                    {bookingData?.hotelInfo.name}
                                </h3>
                                <p className="hotel-address">
                                    {t('pages.booking-detail.hotel-address')}: {bookingData?.hotelInfo.address}
                                </p>
                                <p className="hotel-address">
                                    {t('pages.booking-detail.hotel-phone')}: +{bookingData?.hotelInfo.phone}
                                </p>
                                <p className="hotel-address">
                                    {t('pages.booking-detail.hotel-website')}: <a target='_blank' className="app-link" href={`${bookingData?.hotelInfo.website}`}>{bookingData?.hotelInfo.website}</a>
                                </p>
                                <p className="hotel-address">
                                    {t('pages.booking-detail.hotel-director')}: {bookingData?.hotelInfo.director}
                                </p>
                                <p className="booking-header-resume">
                                    <span>

                                        <Tag
                                            color={
                                                bookingData?.isCancelled
                                                    ? 'red'
                                                    : bookingData?.statusName === 'active'
                                                        ? 'green'
                                                        : bookingData?.statusName === 'postponed'
                                                            ? 'orange'
                                                            : bookingData?.statusName === 'error'
                                                                ? 'red'
                                                                : bookingData?.statusName === 'pending_payment'
                                                                    ? 'purple'
                                                                    : 'blue'
                                            }
                                        >

                                            {t(`booking-status.${bookingData?.statusName}`)}

                                            {bookingData?.statusName === 'canceled' && (
                                                <Tooltip
                                                    title={t('pages.booking-detail.booking-status.cancelled-at', [
                                                        bookingData?.isCancelled
                                                            ? moment(bookingData.lastUpdateDate).format(appConfig.config.dateFormat)
                                                            : 'N/D (2)'
                                                    ])}
                                                >
                                                    <InfoCircleOutlined className="icon-cancelled-at" />
                                                </Tooltip>
                                            )}
                                            {
                                                bookingData?.statusInfo === BookingStatusInfo.ERROR_NOT_REFUNDED ? (
                                                    <InfoCircleOutlined
                                                        className="icon"
                                                        style={{ cursor: 'help', marginLeft: 4 }}
                                                        onMouseEnter={(e) => {
                                                            const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
                                                            setDetailTooltip({
                                                                message: t('pages.booking-detail.booking-status.error-not-refunded') as string,
                                                                x: rect.left,
                                                                y: rect.bottom + 2
                                                            });
                                                        }}
                                                        onMouseLeave={() => setDetailTooltip(null)}
                                                    />
                                                ) : (bookingData?.statusName == "error" && bookingData?.statusInfoMsg) ? (
                                                    <Tooltip title={bookingData.statusInfoMsg}>
                                                        <InfoCircleOutlined className="icon" />
                                                    </Tooltip>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </Tag>
                                        {(
                                            bookingData?.statusInfo === BookingStatusInfo.CANCELLED_BY_USER ||
                                            bookingData?.statusInfo === BookingStatusInfo.ERROR_PRE_AUTHORIZATION ||
                                            
                                            bookingData?.statusName === 'postponed'
                                        ) && (
                                                <Tooltip placement="right" title={retryTooltipText}>
                                                    {isPostponed ? (
                                                        <ClockCircleOutlined
                                                            style={{ color: retryIconColor, cursor: "pointer" }}
                                                            onClick={handleRetryClick}
                                                        />
                                                    ) : (
                                                        <ReloadOutlined
                                                            style={{ color: retryIconColor, cursor: "pointer" }}
                                                            onClick={handleRetryClick}
                                                        />
                                                    )}
                                                </Tooltip>

                                            )}


                                    </span>
                                    <div>
                                        {t('pages.booking-detail.locator')}: {bookingData?.pmsLocator}

                                    </div>
                                    <span>
                                        {t('pages.booking-detail.check-in')}:&nbsp;{moment(bookingData?.bookingLines[0].checkIn!.toString()).format(appConfig.config.dateFormat.split(' ')[0])}
                                    </span>
                                    <span>{t('pages.booking-detail.check-out')}:&nbsp;{moment(bookingData?.bookingLines[0].checkOut!.toString()).format(appConfig.config.dateFormat.split(' ')[0]) + "  "}
                                        <div>
                                            <span className="resume-link" style={{ cursor: 'pointer' }} onClick={() => document.querySelector("[data-tag='rooms']")?.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                                                {
                                                    HTMLReactParser(
                                                        t('pages.booking-detail.room-occupancy', [
                                                            //Total de habitaciones
                                                            bookingData?.bookingLines?.length,
                                                            //Total adultos (aquellos que paxType == adult|teneerger) de todas las habitaciones
                                                            bookingData?.bookingLines.reduce((acc, bookingLine) => acc + bookingLine.paxes?.filter((pax) => pax.paxType === 0 || pax.paxType === 1)?.length, 0),
                                                            //Total niños (aquellos que paxType == child|infant) de todas las habitaciones
                                                            bookingData?.bookingLines.reduce((acc, bookingLine) => acc + bookingLine.paxes?.filter((pax) => pax.paxType === 2 || pax.paxType === 3)?.length, 0),
                                                            bookingData?.extras?.length
                                                        ])
                                                    )
                                                }
                                                {bookingData?.extras && HTMLReactParser(
                                                    t('pages.booking-detail.room-occupancy-extra', [
                                                        bookingData?.extras.length
                                                    ])
                                                )
                                                }
                                            </span>
                                        </div>


                                    </span>
                                </p>
                            </Col>
                            <Col xs={24} lg={10} className="content">
                                <div className="owner-data">
                                    <h3 className="main-title">
                                        {
                                            t('pages.booking-detail.owner-data.title')
                                        }
                                    </h3>
                                    <p className="owner-name">
                                        {t('pages.booking-detail.owner-data.name')}: {bookingData?.ownerData.name} {bookingData?.ownerData.surname} {bookingData?.ownerData.secondSurname}
                                    </p>
                                    <p className="owner-phone">
                                        {t('pages.booking-detail.owner-data.phone')}: {bookingData?.ownerData.phone ?? '-'}
                                    </p>
                                    <p className="owner-phone">
                                        {t('pages.booking-detail.owner-data.email')}: {bookingData?.ownerData.email ? <a className='app-link' href={`mailto:${bookingData?.ownerData.email}`}>{bookingData?.ownerData.email}</a> : '-'}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} className="content">
                                <div className="total-resume">
                                    <Row gutter={0}>
                                        <Col xs={24}>
                                            <div className="agency-more-info" onClick={toogleVisibility}>
                                                {GetShowMoreIcon("plus-icon")} {t('pages.booking-detail.more-agency-info')}
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} className={`agency-more-info-content ${visible ? 'visible' : 'hidden'}`}>
                                            <p>
                                                {t('pages.booking-detail.total-resume.total-commission') + ': '}
                                                <MoneyComponent
                                                    amountOriginal={commission}
                                                    currencyOriginal={currencyBooking}
                                                />
                                                {(commission && commission > 0) ? ` (${(commission / pvpPrice * 100).toFixed(2)}%)` : ''}
                                            </p>
                                            <p>
                                                {t('pages.booking-detail.total-resume.total-net') + ': '}
                                                <MoneyComponent
                                                    amountOriginal={netPrice}
                                                    currencyOriginal={currencyBooking}
                                                />
                                            </p>

                                            <p>{t('pages.booking-detail.total-resume.client-locator')}: <span className="client-locator">{bookingData?.pmsLocator} / {bookingData?.proLocator}</span></p>
                                        </Col>
                                        <Col xs={24} className="total-price">
                                            {t('pages.booking-detail.total-resume.total-price')}
                                            <MoneyComponent
                                                amountOriginal={totalBooking}
                                                currencyOriginal={currencyBooking}
                                            />
                                        </Col>
                                        <Col xs={24} className="price-breakdown" style={{ color: 'grey' }}>
                                            {t('pages.booking-detail.total-resume.payment-method')}: {bookingData?.paymentMethodName || bookingData?.paymentMethodCode}
                                        </Col>
                                        {bookingData?.statusName == 'active' && bookingData.paymentMethodCode.toLocaleLowerCase().includes('tpv') && (
                                            <>
                                                <Col xs={24} className="price-breakdown">
                                                    {t('pages.booking-detail.total-resume.payed')}
                                                    <MoneyComponent
                                                        amountOriginal={bookingData?.payed || 0}
                                                        currencyOriginal={currencyBooking}
                                                    />
                                                </Col>
                                                <Col xs={24} className="price-breakdown">
                                                    {t('pages.booking-detail.total-resume.to-be-payed')}
                                                    <span className={calculateQuantityToBePaid(bookingData?.totalToPay || 0, bookingData?.payed || 0) > 0 ? "red" : ""}>
                                                        <MoneyComponent
                                                            amountOriginal={calculateQuantityToBePaid(bookingData?.totalToPay || 0, bookingData?.payed || 0)}
                                                            currencyOriginal={currencyBooking}
                                                        />
                                                    </span>

                                                </Col>
                                                <Col xs={24} className="payed-by">
                                                    {bookingData.typeCardPayment == GUEST ? t('pages.booking-detail.total-resume.payed-by-guest') : t('pages.booking-detail.total-resume.payed-by-agent')}
                                                </Col>
                                            </>
                                        )}
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} className="content">
                                <div className="btn-actions">
                                    {
                                        (bookingData?.isCancelled === false && theBookingHasntStartedYet(bookingData.bookingLines[0].checkIn) && bookingData.statusName == 'active') ? // solo se pueden canelar las ativas
                                            <Popconfirm
                                                onOpenChange={(e) => {
                                                    if (e && !gettingCancelationFees) {
                                                        onGetBookingCancelSimulationAmount();
                                                    }
                                                }}
                                                okText={t('pages.booking-detail.cancel-booking.ok-text')}
                                                cancelText={t('pages.booking-detail.cancel-booking.cancel-text')}
                                                title={t('pages.booking-detail.cancel-booking.title')}
                                                description={
                                                    <div>
                                                        {gettingCancelationFees ? (
                                                            <div>
                                                                <LoadingOutlined className="loading-icon" />{" "}
                                                                {t('pages.booking-detail.cancel-booking.please-wait')}
                                                            </div>
                                                        ) : (
                                                            <>
                                                                {HTMLReactParser(
                                                                    t('pages.booking-detail.cancel-booking.description', [bookingData?.pmsLocator])
                                                                )}



                                                                {cancelationFees === undefined
                                                                    ? t('pages.booking-detail.cancel-booking.have-penalty', { 0: "N/A", 1: bookingData.currencyCode })
                                                                    : (
                                                                        <>
                                                                            {HTMLReactParser(t('pages.booking-detail.cancel-booking.have-penalty', { 0: '', 1: '' }))}
                                                                            <strong><MoneyComponent amountOriginal={cancelationFees} currencyOriginal={bookingData.currencyCode} /> </strong>
                                                                        </>
                                                                    )
                                                                }
                                                            </>
                                                        )}
                                                    </div>


                                                }
                                                okButtonProps={{ disabled: gettingCancelationFees || cancelligData || cancelationFees === undefined }}
                                                onConfirm={cancelReservation}
                                            >
                                                <Button
                                                    className="app-button danger"
                                                    disabled={cancelligData}
                                                    loading={cancelligData}>

                                                    {!cancelligData && <CloseCircleOutlined />} {t('pages.booking-detail.actions.cancel-booking')}
                                                </Button>
                                            </Popconfirm>
                                            :
                                            <></>
                                    }


                                    <Button className="app-button" onClick={sendCopyByEmail} disabled={isSendingCopyByEmail || isSendingDisabled}>
                                        {
                                            isSendingCopyByEmail ?
                                                <LoadingOutlined className="loading-icon" />
                                                :
                                                ''
                                        }
                                        <MailOutlined /> {t('pages.booking-detail.actions.send-copy-to-client')}
                                    </Button>

                                    {(bookingData?.statusName === 'active' || bookingData?.statusName === 'canceled') && (
                                        <Button className="app-button" onClick={goCustomerVoucher}>
                                            <UserOutlined /> {t('pages.booking-detail.actions.go-customer-voucher')}
                                        </Button>
                                    )}


                                    {
                                        leftTimeToEnableSendButton > 0 ?
                                            <span className="left-time-to-enable-send-button">{t('pages.booking-detail.left-time-to-enable-send-button', [leftTimeToEnableSendButton])}</span>
                                            :
                                            ''
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="rooms print-block" data-tag="rooms">
                        <Row>
                            <Col xs={24} className="content">
                                <h3 className="main-title">
                                    {
                                        t('pages.booking-detail.rooms-title')
                                    }
                                </h3>

                                {
                                    bookingData?.bookingLines.map((bookingLine: BookingLine, index: number) => {
                                        return (
                                            <div className="room">
                                                <Row gutter={0}>
                                                    <Tooltip title={bookingLine.name}>
                                                        <Col xs={24} lg={4} className="room-image" style={{ backgroundImage: `url(${bookingLine.mainImage})` }}>
                                                        </Col>
                                                    </Tooltip>
                                                    <Col xs={24} lg={15} className="room-details">
                                                        <h4>{HTMLReactParser(t("pages.booking-detail.room-for", [
                                                            index + 1,
                                                            bookingLine.name,
                                                            bookingLine.paxes.filter((pax) => pax.paxType === 0 || pax.paxType === 1).length,
                                                            bookingLine.paxes.filter((pax) => pax.paxType === 2 || pax.paxType === 3).length]))}</h4>
                                                        <p className="regime-name">{bookingLine.regimeName}</p>


                                                        <CancellationPolicies cancellationPolicies={bookingLine.cancellationPolicies} currencyCode={bookingData.currencyCode} />

                                                        <Occupation occupation={bookingLine.paxes} checkOut={bookingLine.checkOut} />

                                                    </Col>
                                                    <Col xs={24} lg={5} className="room-price">
                                                        <MoneyComponent
                                                            amountOriginal={parseFloat(bookingData.isNetPrice ? bookingLine.net.toFixed(2) : bookingLine.pvp.toFixed(2))}
                                                            currencyOriginal={bookingData.currencyCode}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        )
                                    })
                                }
                            </Col>
                        </Row>
                    </div>
                    {bookingData?.extras && <div className="services print-block" data-tag="extras">
                        <Row>
                            <Col xs={24} className="content">
                                <h3 className='main-title'>
                                    {t('pages.booking-detail.extra-services.title')}
                                </h3>

                                <div>
                                    {
                                        bookingData?.extras.map((extra: Extra, index: number) => {
                                            return (
                                                <div className="service">
                                                    <Row gutter={0}>
                                                        <Tooltip title={extra.description}>
                                                            <Col xs={24} lg={4} className="image" style={{ backgroundImage: `url(${extra.image})` }}>
                                                            </Col>
                                                        </Tooltip>
                                                        <Col xs={24} lg={15} className="description">
                                                            <h4>{index + 1}. {extra.description}</h4>
                                                            <p>{t('pages.booking-detail.extra-services.quantity')}: {extra.quantity} </p>
                                                            <p>{t('pages.booking-detail.extra-services.date')}: {moment(extra.applicationDateFrom).format(appConfig.config.dateFormat)} - {moment(extra.applicationDateTo).format(appConfig.config.dateFormat)}</p>
                                                        </Col>
                                                        <Col xs={24} lg={5} className="service-price">

                                                            <span>
                                                                {extra.price > 0 ? (
                                                                    <MoneyComponent
                                                                        amountOriginal={extra.price}
                                                                        currencyOriginal={currencyBooking}
                                                                    />
                                                                ) : (
                                                                    t('pages.booking-detail.extra-services.free')
                                                                )}
                                                            </span>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </Col>
                        </Row>

                    </div>
                    }
                </div>
            </div>
            {detailTooltip && createPortal(
                <div
                    className="payment-method-tooltip"
                    style={{ top: detailTooltip!.y, left: detailTooltip!.x }}
                >
                    {detailTooltip!.message}
                </div>,
                document.body
            )}
            </>
        )
    }

}
export default BookingDetailPage;